const findBy = (collection = [], value, dataIndex = 'data') =>
  collection.find(item => item[dataIndex] === value) || {};

export default findBy;
